var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style.logo, _vm.$style[_vm.color]]},[_c('div',[_c('div',{class:[_vm.$style.title, _vm.$style[_vm.color]]},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{class:[_vm.$style.subtitle, _vm.$style[_vm.color]]},[_vm._v(" Ver: "+_vm._s(_vm.version)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }